/**
 * @Author  : Luo
 * @Time    : 2020/7/30 18:08
 */

'use strict'
import Vue from 'vue'

import NoticeTemplate from './index.vue'

const NoticeConstructor = Vue.extend(NoticeTemplate)

const Notice = {
  init: (options) => {
    if (typeof options === 'undefined') options = {}
    if (typeof options.type === 'undefined') options.type = 'info'
    if (typeof options.duration === 'undefined') options.duration = 5000
    if (typeof options.content === 'undefined') options.content = '这是一条消息'
    if (typeof options.top === 'undefined') options.top = 20

    // 每添加一个notice 通多增加高度实现不重叠的效果
    let tempLen = 1
    for (let item of document.body.children) {
      if (item.classList.value.indexOf('notice_container') > -1) tempLen++
    }
    options.top = options.top + 80 * (tempLen - 1)

    let tempNotice = new NoticeConstructor({
      data: options
    }).$mount()

    document.body.appendChild(tempNotice.$el)

    Vue.nextTick(() => {
      tempNotice.visible = true
    })
  }
}

Vue.prototype.$notice = Notice.init



// WEBPACK FOOTER //
// ./src/components/notice/index.js